import React from "react";
import {
    ArrowSortDownRegular,
    ArrowSortUpRegular,
} from "@fluentui/react-icons";
import { Flex, Text } from "@fluentui/react-northstar";
import { useSortingData } from "../../stores/sorting.store";

const CellHeaderDate = ({ title = "", canSort = false }) => {
    const store_sort = useSortingData();
    return (
        <Flex gap="gap.smaller" vAlign="center">
            <Text content={title} />
            {canSort &&
                (store_sort.sortByDate === "asc" ? (
                    <ArrowSortDownRegular
                        color="var(--color-primary)"
                        cursor={"pointer"}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            store_sort.setSortByDate(
                                store_sort.sortByDate === "asc" ? "desc" : "asc"
                            );
                        }}
                    />
                ) : (
                    <ArrowSortUpRegular
                        color="var(--color-primary)"
                        cursor={"pointer"}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            store_sort.setSortByDate(
                                store_sort.sortByDate === "asc" ? "desc" : "asc"
                            );
                        }}
                    />
                ))}
        </Flex>
    );
};

export default CellHeaderDate;
